import React, { useState } from 'react';
import { Box, TextField, Button, Avatar } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

interface CommentFormProps {
  onSubmit: (body: string) => Promise<void>;
  parentCommentId?: string | null;
  placeholder?: string;
}

const CommentForm: React.FC<CommentFormProps> = ({ onSubmit, parentCommentId, placeholder = 'Write a comment…' }) => {
  const { user } = useAuth();
  const [body, setBody] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!body.trim()) return;
    setSubmitting(true);
    try {
      await onSubmit(body.trim());
      setBody('');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
      <Avatar src={user?.profilePicture} alt={user?.displayName} sx={{ width: 32, height: 32, mt: 0.5 }}>
        {user?.displayName?.[0]}
      </Avatar>
      <Box sx={{ flexGrow: 1 }}>
        <TextField
          fullWidth
          multiline
          minRows={2}
          maxRows={6}
          placeholder={placeholder}
          value={body}
          onChange={(e) => setBody(e.target.value)}
          size="small"
          disabled={submitting}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
          <Button type="submit" variant="contained" size="small" disabled={!body.trim() || submitting}>
            {parentCommentId ? 'Reply' : 'Comment'}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default CommentForm;
